export const SET_INTERNAL_TRANSITION = 'SET_INTERNAL_TRANSITION';
export const SET_CURRENT_PATH = 'SET_CURRENT_PATH';
